// src/Components/DatabaseCheck.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Constants from '../Utilities/Constants';

const DatabaseCheck = ({ children }) => {
    const [dbStatus, setDbStatus] = useState('checking'); // 'checking', 'connected', 'failed'
    const [error, setError] = useState('');

    useEffect(() => {
        checkDatabaseConnection();
    }, []);

    const checkDatabaseConnection = async () => {
        try {
            const response = await axios.get(Constants.API_URL_HEALTH_CHECK, {
                timeout: 10000 // 10 second timeout
            });
            
            if (response.status === 200) {
                setDbStatus('connected');
            }
        } catch (error) {
            console.error('Database connection failed:', error);
            setDbStatus('failed');
            setError(error.response?.data?.error || error.message || 'שגיאת חיבור למסד הנתונים');
        }
    };

    const retry = () => {
        setDbStatus('checking');
        setError('');
        checkDatabaseConnection();
    };

    if (dbStatus === 'checking') {
        return (
            <div className="container-fluid d-flex justify-content-center py-5">
                <div className="text-center">
                    <div className="spinner-border text-primary mb-3" style={{width: '3rem', height: '3rem'}} role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <h3>טוען...</h3>
                    <p>כבר מתחילים</p>
                </div>
            </div>
        );
    }

    if (dbStatus === 'failed') {
        return (
            <div className="container-fluid d-flex justify-content-center py-5">
                <div className="text-center">
                    <div className="alert alert-danger" style={{maxWidth: '500px'}}>
                        <h1 className="display-1">⚠️</h1>
                        <h2 className="alert-heading">שגיאת חיבור</h2>
                        <p className="mb-3">לא ניתן להתחבר למסד הנתונים</p>
                        <hr />
                        <p className="mb-3"><strong>פרטי השגיאה:</strong><br />{error}</p>
                        <button 
                            className="btn btn-primary btn-lg me-3" 
                            onClick={retry}
                        >
                            🔄 נסה שוב
                        </button>
                        <a 
                            href="mailto:support@ozaviad.co.il" 
                            className="btn btn-outline-secondary btn-lg"
                        >
                            📧 צור קשר
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    // Database is connected, render the app
    return children;
};

export default DatabaseCheck;